module.exports = __webpack_public_path__ + "img/524.29f3420f.png";